const edit = {
  path: 'edit/:storeId',
  component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/edit'], resolve),
  meta: {
    requireAuth: true
  }
}

export default edit